import React from 'react';

import ClockIcon from 'Assets/icons/clock.svg';
import ListIcon from 'Assets/icons/list.svg';

export default function UncommittedExpendituresCreateInProgressList(props) {
    function clickRow(uncommittedExpenditureGroupId) {
        window.location.href = props.committedExpendituresCreateUrl.replace('UNCOMMITTED_EXPENDITURE_GROUP_ID', uncommittedExpenditureGroupId);
    }

    return (
        <div className="row mt-3">
            <div className="col">
                <div className="card bg-white border-0 rounded-15px shadow py-2">
                    {Object.keys(props.uncommittedExpenditureGroups).length > 0 && (
                        <div className="card-body">
                            <h6 className="text-blue font-weight-600 mb-2">Or continue committing expenditures:</h6>
                            <ul className="list-group">
                                {props.uncommittedExpenditureGroups.map((uncommittedExpenditureGroup) => {
                                    return (
                                        <li
                                            key={uncommittedExpenditureGroup.id}
                                            className="list-group-item"
                                            onClick={() => clickRow(uncommittedExpenditureGroup.id)}
                                        >
                                            {uncommittedExpenditureGroup.uncommitted_expenditures.map((uncommittedExpenditure) => {
                                                return <p key={uncommittedExpenditure.id}>{uncommittedExpenditure.expense.name}</p>;
                                            })}
                                            {uncommittedExpenditureGroup.status == 1 && (
                                                <label
                                                    className={'font-italic text-primary float-left mt-3'}
                                                    onClick={() => clickRow(uncommittedExpenditureGroup.id)}
                                                >
                                                    <ClockIcon className="tw-w-2.5 tw-h-2.5" />
                                                    Commit Expenditures Requested
                                                </label>
                                            )}
                                            <label
                                                className={'font-italic text-secondary float-right mt-3'}
                                                onClick={() => clickRow(uncommittedExpenditureGroup.id)}
                                            >
                                                <ListIcon className="tw-w-2.5 tw-h-2.5" />
                                                Click row to continue committing this expenditures
                                            </label>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                    {Object.keys(props.uncommittedExpenditureGroups).length == 0 && (
                        <div className="card-body">There are no expenditures being committed right now</div>
                    )}
                </div>
            </div>
        </div>
    );
}
